import React, { useEffect, useState } from "react";
import { IFilterInscription, getDefaultFilterInscription } from "../../models/interfaces/IFilterInscription";
import { ISorter } from "../../models/interfaces/ISorter";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import { IInscription } from "../../models/interfaces/IInscription";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
import CpntPagination from "../../components/CpntPagination";
import InscriptionsFilter from "./components/InscriptionsFilter";
import SpinnerEditeurPro from "../FO/components/SpinnerEditeurPro";
import { useKeycloak } from "@react-keycloak/web";
import { useFetchBODemandesInscriptionsQuery } from "../../redux/slice/api/BO/demandeInscriptionApi";

const PageBOInscriptions: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterInscription>();
  const [searchParams, setSearchParams] = useState<IFilterInscription>();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number | null>(null);
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterInscriptions");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterInscription());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter: ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterInscription()) {
      const _filter: IFilterInscription = {
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset })
      };
      setSearchParams(_filter);
      localStorage.setItem("IFilterInscriptions", JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  // Utilisation de l'API RTK Query
  const { data: InscriptionsResult, isFetching, error } = useFetchBODemandesInscriptionsQuery(searchParams, {
    skip: !keycloakinitialized || !keycloak.authenticated || !searchParams,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (InscriptionsResult) {
      setNumberOfResults(InscriptionsResult?.Quantite ?? null);
    }
  }, [InscriptionsResult]);

  const applyFilter = (data: IFilterInscription) => {
    setListFilter(data);
  };

  useEffect(() => {
    listfilter?.Offset && setOffset(listfilter?.Offset);
    listfilter?.Limit && setLimit(listfilter?.Limit);
  }, [listfilter]);

  const actions: ILocation[] = [
    {
      PathsName: { VoirInscription: "/admin/inscription/[[Id]]" },
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
      Visible: () => true
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "Id",
      Name: "Id",
      Class: "",
      sorter: (a: IInscription, b: IInscription) => 0
    },
    {
      Id: "RaisonSociale",
      Name: "Raison sociale",
      Class: "",
      sorter: (a: IInscription, b: IInscription) => 0
    },
    {
      Id: "NomAdministrateur",
      Name: "Nom administrateur",
      Class: "",
      sorter: (a: IInscription, b: IInscription) => 0
    },
    {
      Id: "Email",
      Name: "E-mail",
      Class: "",
      sorter: (a: IInscription, b: IInscription) => 0
    },
    {
      Id: "DateCreation",
      Name: "Date création",
      Class: "",
      sorter: (a: IInscription, b: IInscription) => 0
    },
    {
      Id: "LibelleEtat",
      Name: "Statut",
      Class: "",
      sorter: (a: IInscription, b: IInscription) => 0
    },
  ];

  const dataItemsStyle = {
    Id: "",
    RaisonSociale: "",
    NomAdministrateur: "",
    Email: "",
    DateCreation: "",
    LibelleEtat: "",
  };

  return (
    <>
      <div className="container text-start ">
        <div className="row pt-3 pb-5">
          <div className="col col-12 ">
            <h2 className="titreModule titre-bleu">
              <i className="bi-person-plus pe-2" />
              Gestion des demandes d&apos;inscription
            </h2>
          </div>
        </div>
        <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <InscriptionsFilter
                filter={searchParams}
                changeFilter={applyFilter}
              />
            </>
          )}
        </div>
        <div className="row ">
          {numberOfResults !== null && InscriptionsResult?.Demandesinscriptions && (
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
            </div>
          )}
          {isFetching ? (
            <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            InscriptionsResult?.Demandesinscriptions && numberOfResults !== null && numberOfResults > 0 && (
              <>
                <CpntPagination
                  limit={limit}
                  offset={offset}
                  numberOfResults={numberOfResults}
                  setLimit={(Limit) => setLimit(Limit)}
                  setOffset={(offset) => setOffset(offset)}
                />

                <div className="card p-0 mb-2">
                  <div className="table-responsive">
                    <CpntDataTable
                      data={InscriptionsResult && InscriptionsResult?.Demandesinscriptions ? 
                        InscriptionsResult.Demandesinscriptions.map(item => ({
                          ...item,
                          NomAdministrateur: `${item.Nom || ''} ${item.Prenom || ''}`.trim()
                        })) : []}
                      dataHeader={dataHeaderName}
                      dataItemsStyle={dataItemsStyle}
                      actions={actions}
                      actualFilterPage="PageBOInscriptions"
                      updateSorter={setSortField}
                      updateDescending={setIsDescending}
                    />
                  </div>
                </div>
                <CpntPagination
                  limit={limit}
                  offset={offset}
                  numberOfResults={numberOfResults}
                  setLimit={(Limit) => setLimit(Limit)}
                  setOffset={(offset) => setOffset(offset)}
                />
              </>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default PageBOInscriptions;
